export const CONGESTION_COLORS = {
  N: "#008000", // Green (non-congested)
  L: "#00FF00", // Light green
  M: "#FFFF00", // Yellow (moderate)
  H: "#FF0000", // Red (heavy)
  X: "#000000", // Black (closed)
  U: "#777777", // Gray (unknown)
};

export const getCongestionColor = (cng) => CONGESTION_COLORS[cng] || "#777777";

// Speed thresholds in m/s matching CongestionLevelType.fromExpresswaySpeed()
// 55 mph = 24.587 m/s, 35 mph = 15.646 m/s, 15 mph = 6.706 m/s
const FREE_FLOW_MPS = 55 / 2.236936;
const LIGHT_MPS = 35 / 2.236936;
const MEDIUM_MPS = 15 / 2.236936;

/**
 * Map a speed in m/s to a congestion color, using the same thresholds as
 * CongestionLevelType.fromExpresswaySpeed() on the backend.
 */
export const getColorForSpeed = (speedMps) => {
  if (speedMps >= FREE_FLOW_MPS) return "#008000"; // Green
  if (speedMps >= LIGHT_MPS) return "#00FF00"; // Light green
  if (speedMps >= MEDIUM_MPS) return "#FFFF00"; // Yellow
  if (speedMps > 0) return "#FF0000"; // Red
  return "#777777"; // Unknown/no data
};
